import { Tag } from 'antd';
import styled from 'styled-components';

export const PriceBadge = ({ children, ...props }) => {
    return <StyledPriceBadge {...props}>{children}</StyledPriceBadge>;
};

const StyledPriceBadge = styled(Tag)`
    display: inline-block;
    padding: 4px 12px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 400;
    background: #e8edf2 !important;
    color: #5e5e5e !important;
    font-family: var(--font-family-geist);
    text-align: center;
    min-width: 80px;
    box-sizing: border-box;
    border: none !important;
    margin: 0 !important;

    @media (max-width: 768px) {
        font-size: 13px;
        padding: 3px 10px;
        min-width: 70px;
    }

    @media (max-width: 480px) {
        font-size: 12px;
        padding: 2px 8px;
        min-width: 60px;
    }
`;

export default PriceBadge;
